import React from 'react';
import SvgIcon from './SvgIcon';

const Lookout = props => (
    <SvgIcon viewBox="0 0 17 16" {...props}>
        <defs>
            <path
                d="M15.2,7.7 L15.2,7.7 C14.4,6.6 12.3,3.8 11.5,2.7 L11.5,2.7 C11.1,2.3 10.6,2 10,2 C8.9,2 8,2.9 8,4 C8,2.9 7.1,2 6,2 C5.4,2 4.9,2.3 4.5,2.7 L4.5,2.7 C3.7,3.7 1.6,6.5 0.8,7.7 L0.8,7.7 C0.3,8.3 0,9.1 0,10 C0,12.2 1.8,14 4,14 C6.2,14 8,12.2 8,10 C8,12.2 9.8,14 12,14 C14.2,14 16,12.2 16,10 C16,9.1 15.7,8.3 15.2,7.7 Z M4,12 C2.9,12 2,11.1 2,10 C2,8.9 2.9,8 4,8 C5.1,8 6,8.9 6,10 C6,11.1 5.1,12 4,12 Z M12,12 C10.9,12 10,11.1 10,10 C10,8.9 10.9,8 12,8 C13.1,8 14,8.9 14,10 C14,11.1 13.1,12 12,12 Z"
                id="path-1"
            ></path>
        </defs>
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="map-tools" transform="translate(-1146.000000, -243.000000)">
                <g id="Group" transform="translate(1117.000000, 148.000000)">
                    <g id="LOOKOUT" transform="translate(10.000000, 95.000000)">
                        <g id="lookout" transform="translate(19.500000, 0.000000)">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <use id="Shape" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-1"></use>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

Lookout.displayName = 'LookoutIcon';

export default Lookout;
